import {
  User, MessageSquare, ArrowDownCircle, ArrowUpCircle,
  Gift, History, Users, ShieldCheck, Lock, Ticket, TicketPercent, ReceiptText,
} from 'lucide-react';

const accountItems = [
  { to: '/hesap/profil', icon: User, label: 'Profilim' },
  { to: '/hesap/guvenlik', icon: Lock, label: 'Güvenlik' },
  {
    to: '/hesap/kyc',
    icon: ShieldCheck,
    label: 'KYC Doğrulama',
  },
  { to: '/hesap/mesajlar', icon: MessageSquare, label: 'Mesajlarım' },
  { to: '/hesap/para-yatir', icon: ArrowDownCircle, label: 'Para Yatır' },
  { to: '/hesap/para-cek', icon: ArrowUpCircle, label: 'Para Çek' },
  { to: '/hesap/islemler', icon: ReceiptText, label: 'Hesap Hareketleri' },
  { to: '/promosyonlar', icon: Gift, label: 'Bonuslarım' },
  { to: '/promosyon-kodu', icon: TicketPercent, label: 'Promosyon Kodu' },
  { to: '/hesap/kayip-bonusu', icon: Gift, label: 'Kayıp Bonusu' },
  { to: '/hesap/affiliate', icon: Users, label: 'Affiliate' },
  { to: '/hesap/oyun-gecmisi', icon: History, label: 'Oyun Geçmişi' },
  { to: '/hesap/bahis-kuponlari', icon: Ticket, label: 'Bahis Kuponlarım' },
];

const adminItem = {
  to: '/admin',
  icon: ShieldCheck,
  label: 'Yönetim Paneli',
  admin: true,
};

// Menüdeki "Bonuslarım" kampanya listesine değil hesap bölümündeki kendi
// sayfasına gider (`/hesap/bonuslarim`): oyuncunun çevrimi süren bonusu,
// freespin ve freebet hakları oradadır ve kartlar Bonuslar sayfasında
// kampanyaları ekranın altına itiyordu (pages/Promotions.jsx `MyRewards`).
// Menünün kendisi değil **hedefi** değişir: kampanyalara giden yol üst
// menüde ve Bonuslar sayfasının kendi adresinde durmaya devam eder.
const MENU_REDIRECT = { '/promosyonlar': '/hesap/bonuslarim' };

// Şemaya özel menü düzenlemeleri. Betrun ve Merit'te "Kayıp Bonusu" menüde
// yoktur: orada kayıp bonusu Bonuslar sayfasından talep edilir
// (pages/Promotions.jsx `LOSS_BONUS_ON_PROMOTIONS_THEMES`, 16.10.2026). Sayfa
// adresle açılmaya devam eder, yalnızca kısayol düşer.
const THEME_MENU = {
  betrun: {
    hidden: new Set(['/hesap/kayip-bonusu']),
  },
  merit: {
    hidden: new Set(['/hesap/kayip-bonusu']),
  },
};

// Promosyon Kodu bu listenin bir maddesidir ama rotası hesap bölümünün
// dışındadır (`/promosyon-kodu`; ziyaretçiye açık olup olmadığı panel
// ayarıdır, `promo_code_guest_view`); giriş yapmış üyeye hesap kabuğunun içinde
// çizilir (bkz. App.js `PromoCodeRoute`).

// ``sportsEnabled`` panelden spor kapatıldığında kupon sekmesini gizler;
// ayar yüklenmeden çağrıldığında sekme görünür kalır (varsayılan açıktır).
//
// ``adminVisible`` yönetim paneli ayrı bir alan adına kilitlendiğinde kısayolu
// düşürür: bağlantı bu adreste hiçbir şey açmaz (bkz. lib/adminDomain.js).
export const getAccountMenuItems = (
  user, { sportsEnabled = true, adminVisible = true, themeId = '' } = {},
) => {
  const themeMenu = THEME_MENU[themeId];
  const visibleItems = accountItems.filter(
    (item) => (
      (item.to !== '/hesap/affiliate' || user?.can_use_affiliate)
      && (
        item.to !== '/hesap/kyc'
        || !user?.kyc_verified
      )
      && (item.to !== '/hesap/bahis-kuponlari' || sportsEnabled)
      && !themeMenu?.hidden?.has(item.to)
    ),
  ).map((item) => (
    MENU_REDIRECT[item.to] ? { ...item, to: MENU_REDIRECT[item.to] } : item
  ));
  return user?.is_admin && adminVisible
    ? [adminItem, ...visibleItems] : visibleItems;
};
